import React, { useEffect, useState } from 'react';
import { Button, Box, Typography, TextField, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { Male, Female } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setPlayers } from '../features/contestants/contestantsSlice';
import { useNavigate } from 'react-router-dom';
import BaseButton from '../components/BaseButton';
import BackgroundContainer from '../components/BackgroundContainer';
import BaseTextField from '../components/BaseTextField';
import GenderButton from '../components/GenderButton';
import BaseHeader from '../components/BaseHeader';
import MenuButton from '../components/MenuButton';


const Contestants = () => {
  const [playerOneName, setPlayerOneName] = useState('');
  const [playerTwoName, setPlayerTwoName] = useState('');
  const [playerOneGender, setPlayerOneGender] = useState('');
  const [playerTwoGender, setPlayerTwoGender] = useState('');

  useEffect(() => {
    if (playerOne) setPlayerOneName(playerOne.name);
    if (playerOne) setPlayerOneGender(playerOne.gender);
    if (playerTwo) setPlayerTwoName(playerTwo.name);
    if (playerTwo) setPlayerTwoGender(playerTwo.gender);
  }, []);

  const playerOne = useSelector((state) => state.contestants.playerOne);
  const playerTwo = useSelector((state) => state.contestants.playerTwo);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isSameSex = playerOneGender !== '' && playerOneGender === playerTwoGender;

  const handleNext = () => {
    dispatch(setPlayers({ playerOneName, playerTwoName, playerOneGender, playerTwoGender }));
    navigate('/chooserelationship');
  };

  const isNextButtonDisabled = () => {
    return playerOneName === '' || playerTwoName === '' || playerOneGender === '' || playerTwoGender === '' || isSameSex;
  }

  return (
    <BackgroundContainer sx={{overflow: 'hidden'}}>
      <MenuButton
      showLogin={true}
      showAccount={true}
      faq={true}
      showDownload={true}
      />
      <Box
      sx={{
        flexGrow: 1,
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 80px)', // room for header + footer buttons
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <BaseHeader  sx={{
    marginBottom: '1rem',
    textAlign: 'center',
    fontSize: '3.5rem', // 🎯 Full size title
    '@media (max-width: 450px)': {
      fontSize: '3.2rem', // 🧠 Gentle scale-down on ultra-small screens
    },'@media (max-width: 414px)': {
      fontSize: '2.9rem', // 🧠 Gentle scale-down on ultra-small screens
    },'@media (max-width: 380px)': {
      fontSize: '2.7rem', // 🧠 Gentle scale-down on ultra-small screens
    },
    '@media (max-width: 320px)': {
      fontSize: '2.7rem', // 🔒 Last-resort fallback for smallest devices
    },
  }}
>
        Who's Playing?
      </BaseHeader>
      
      <Box
  sx={{
    flexGrow: 1,
    overflowY: 'visible',
    maxHeight: 'calc(100vh - 120px)', // room for header + footer buttons
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1rem',
    width: '100%',
    boxSizing: 'border-box',
  }}
>
        {/* Player One Input */}
        <BaseTextField 
        sx={{
          width: '100%',
          maxWidth: '250px', // 📏 Looks good on larger screens
          fontSize: '1.1rem',
          '& .MuiInputBase-input': {
            padding: '12px',
            fontSize: '1.1rem',
            '@media (max-width: 360px)': {
              padding: '10px',
              fontSize: '1rem', // 🧠 Slightly smaller on small phones
            },
            '@media (max-width: 320px)': {
              padding: '8px',
              fontSize: '0.95rem', // 🧬 Tighter on very narrow phones
            },
          },
        }}
          label="Player One Name"
          value={playerOneName}
          inputProps={{ maxLength: 15 }}
          onChange={(e) => {
            const value = e.target.value;
            setPlayerOneName(value.charAt(0).toUpperCase() + value.slice(1));
          }}
        />
        <Box display="flex" justifyContent="center" alignItems="center">
          <GenderButton 
            className={playerOneGender === 'male' ? 'male' : ''} 
            onClick={() => setPlayerOneGender('male')}
          >
            <Male />
          </GenderButton>
          <GenderButton 
            className={playerOneGender === 'female' ? 'female' : ''} 
            onClick={() => setPlayerOneGender('female')}
          >
            <Female />
          </GenderButton>
        </Box>

        {/* Player Two Input */}
        <BaseTextField
          sx={{
            width: '100%',
            maxWidth: '250px', // 📏 Looks good on larger screens
            fontSize: '1.1rem',
            '& .MuiInputBase-input': {
              padding: '12px',
              fontSize: '1.1rem',
              '@media (max-width: 360px)': {
                padding: '10px',
                fontSize: '1rem', // 🧠 Slightly smaller on small phones
              },
              '@media (max-width: 320px)': {
                padding: '8px',
                fontSize: '0.95rem', // 🧬 Tighter on very narrow phones
              },
            },
          }}
          label="Player Two Name"
          value={playerTwoName}
          inputProps={{ maxLength: 15 }}
          onChange={(e) => {
            const value = e.target.value;
            setPlayerTwoName(value.charAt(0).toUpperCase() + value.slice(1));
          }}
        />
        <Box display="flex" justifyContent="center" alignItems="center"  >
          <GenderButton 
            className={playerTwoGender === 'male' ? 'male' : ''} 
            onClick={() => setPlayerTwoGender('male')}
          >
            <Male />
          </GenderButton>
          <GenderButton 
            className={playerTwoGender === 'female' ? 'female' : ''} 
            onClick={() => setPlayerTwoGender('female')}
          >
            <Female />
          </GenderButton>
        </Box>

        {isSameSex && (
          <Box sx={{ textAlign: 'center', px: 2, pb: 1 }}>
            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem' }}>
              Same-sex mode coming soon
            </Typography>
          </Box>
        )}
      </Box>
        <Box sx={{ marginTop: '10px',marginBottom: '10px' , display: 'flex', justifyContent: 'center' }}>
        <BaseButton onClick={() => navigate('/')}>Back</BaseButton>
        <BaseButton onClick={handleNext} disabled ={isNextButtonDisabled()}>Next</BaseButton>
        </Box>
        </Box>
    </BackgroundContainer>
  );
};

export default Contestants